export function getLangData(edges, lang) {
  const language = lang === 'en' ? 'en-us' : lang;
  return edges.filter((edge) => edge.node.lang === language.toLowerCase())[0]
    .node.data;
}
